//SIDEBAR SLIDER
export const OPEN_SLIDER = "OPEN_SLIDER";
export const CLOSE_SLIDER = "CLOSE_SLIDER";
export const SELECTED_MENU_ITEM = "SELECTED_MENU_ITEM";

//HEADER BUTTON
export const SET_HEADER_BUTTON_PARAMS = "SET_HEADER_BUTTON_PARAMS";
export const SET_HEADER_TEXT = "SET_HEADER_TEXT";
export const SET_HEADER_ADVANCED_SEARCH_PARAMS = "SET_HEADER_ADVANCED_SEARCH_PARAMS";

//COURSES MODULE
export const COURSES_IS_LOADING = "COURSES_IS_LOADING";
export const COURSES_LOAD_SUCCESS = "COURSES_LOAD_SUCCESS";
export const COURSES_LOAD_ERROR = "COURSES_LOAD_ERROR";
export const COURSES_INTEGRITY_ERROR = "COURSES_INTEGRITY_ERROR";
export const RESET_INTERGRITY_ERROR = "RESET_INTERGRITY_ERROR";

//COMMON FORM ACTIONS
export const IS_SUBMITTING = "IS_SUBMITTING";
export const SUBMIT_SUCCESS = "SUBMIT_SUCCESS";
export const SUBMIT_ERROR = "SUBMIT_ERROR";
export const RESET_FORM_STATUS = "RESET_FORM_STATUS";
export const IS_UPDATING = "IS_UPDATING";
export const UPDATE_SUCCESS = "UPDATE_SUCCESS";
export const UPDATE_ERROR = "UPDATE_ERROR";

//QUESTIONS FORM ACTIONS
export const IS_SUBMITTING_QUESTIONS = "IS_SUBMITTING_QUESTIONS";
export const SUBMIT_QUESTIONS_SUCCESS = "SUBMIT_QUESTIONS_SUCCESS";
export const SUBMIT_QUESTIONS_ERROR = "SUBMIT_QUESTIONS_ERROR";
export const RESET_QUESTIONS_FORM_STATUS = "REST_QUESTIONS_FORM_STATUS";

//TOPICS MODULE
export const TOPICS_IS_LOADING = "TOPICS_IS_LOADING";
export const TOPICS_LOAD_SUCCESS = "TOPICS_LOAD_SUCCESS";
export const TOPICS_LOAD_ERROR = "TOPICS_LOAD_ERROR";

//EDIT FORM ACTIONS
export const SET_EDIT = "SET_EDIT";
export const RESET_EDIT = "RESET_EDIT";

//SETTINGS MODULE
export const SETTINGS_IS_LOADING = "SETTINGS_IS_LOADING";
export const SETTINGS_LOAD_SUCCESS = "SETTINGS_LOAD_SUCCESS";
export const SETTINGS_LOAD_ERROR = "SETTINGS_LOAD_ERROR";

//QUIZZES MODULE
export const QUIZZES_IS_LOADING = "QUIZZES_IS_LOADING";
export const QUIZZES_LOAD_SUCCESS = "QUIZZES_LOAD_SUCCESS";
export const QUIZZES_LOAD_ERROR = "QUIZZES_LOAD_ERROR";
export const RESET_QUIZZES_DATA = "RESET_QUIZZES_DATA";
export const QUIZ_CREATED = "QUIZ_CREATED";

//LOAD QUESTIONS FOR EDITING
export const IS_LOADING = "IS_LOADING";
export const LOAD_SUCCESS = "LOAD_SUCCESS";
export const LOAD_ERROR = "LOAD_ERROR";
export const RESET_LOADED_QUESTIONS = "RESET_LOADED_QUESTIONS";

// ANNOUNCEMENTS MODULE
export const ANNOUNCEMENTS_IS_LOADING = "ANNOUNCEMENTS_IS_LOADING";
export const ANNOUNCEMENTS_LOAD_SUCCESS = "ANNOUNCEMENTS_LOAD_SUCCESS";
export const ANNOUNCEMENTS_LOAD_ERROR = "ANNOUNCEMENTS_LOAD_ERROR";

// STATISTICS - DASHBOARD MODULE
export const STATISTICS_IS_LOADING = "STATISTICS_IS_LOADING";
export const STATISTICS_LOAD_SUCCESS = "STATISTICS_LOAD_SUCCESS";
export const STATISTICS_LOAD_ERROR = "STATISTICS_LOAD_ERROR";

// LEADERSHIP BOARD - DASHBOARD MODULE
export const LEADERSHIP_BOARD_IS_LOADING = "LEADERSHIP_BOARD_IS_LOADING";
export const LEADERSHIP_BOARD_LOAD_SUCCESS = "LEADERSHIP_BOARD_LOAD_SUCCESS";
export const LEADERSHIP_BOARD_LOAD_ERROR = "LEADERSHIP_BOARD_LOAD_ERROR";

// REPORTS MODULE
export const REPORTS_IS_LOADING = "REPORTS_IS_LOADING";
export const REPORTS_LOAD_SUCCESS = "REPORTS_LOAD_SUCCESS";
export const REPORTS_LOAD_ERROR = "REPORTS_LOAD_ERROR";

//LIVE COURSES MODULE
export const LIVE_COURSES_IS_LOADING = "LIVE_COURSES_IS_LOADING";
export const LIVE_COURSES_LOAD_SUCCESS = "LIVE_COURSES_LOAD_SUCCESS";
export const LIVE_COURSES_LOAD_ERROR = "LIVE_COURSES_LOAD_ERROR";

//ACCESS_TOKEN LIVE SESSIONS
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const RESET_ACCESS_TOKEN = "RESET_ACCESS_TOKEN";

//SELECTED COURSE
export const SELECTED_COURSE_IS_LOADING = 'SELECTED_COURSE_IS_LOADING';
export const SELECTED_COURSE_LOAD_SUCCESS = 'SELECTED_COURSE_LOAD_SUCCESS';
export const SELECTED_COURSE_LOAD_ERROR = 'SELECTED_COURSE_LOAD_ERROR';
export const RESET_SELECTED_COURSE = 'RESET_SELECTED_COURSE';

//SEARCH FUNCTION AUTOCOMPLETE
export const SEARCH_AUTOCOMPLETE_LIST_LOADING = 'SEARCH_AUTOCOMPLETE_LIST_LOADING';
export const SEARCH_QUERY_LOADING = "SEARCH_QUERY_LOADING";
export const SEARCH_COMPONENT_RESET = "SEARCH_COMPONENT_RESET";
export const SEARCH_FINAL_QUERY = "SEARCH_FINAL_QUERY";
export const SET_AUTOCOMPLETE_VISIBILITY = "SET_AUTOCOMPLETE_VISIBILITY";

//SELECTED VIEW IN COURSE
export const CURRENT_VIEW = 'CURRENT_VIEW';
export const RESET_VIEW = 'RESET_VIEW';

//ADVANCED SEARCH
export const SET_ADVANCED_SEARCH = 'SET_ADVANCED_SEARCH';
export const RESET_ADVANCED_SEARCH = 'RESET_ADVANCED_SEARCH';

//COMMENTS
export const COMMENTS_IS_LOADING = "COMMENTS_IS_LOADING";
export const COMMENTS_LOAD_SUCCESS = "COMMENTS_LOAD_SUCCESS";
export const COMMENTS_LOAD_ERROR = "COMMENTS_LOAD_ERROR";
export const COMMENTS_RESET = "COMMENTS_RESET";

// COURSE LEADERSHIP BOARD - COURSE DASHBOARD MODULE
export const COURSE_LEADERSHIP_BOARD_IS_LOADING = "COURSE_LEADERSHIP_BOARD_IS_LOADING";
export const COURSE_LEADERSHIP_BOARD_LOAD_SUCCESS = "COURSE_LEADERSHIP_BOARD_LOAD_SUCCESS";
export const COURSE_LEADERSHIP_BOARD_LOAD_ERROR = "COURSE_LEADERSHIP_BOARD_LOAD_ERROR";

// HEADER PROFILE AND NOTIFICATIONS
export const HEADER_NOTIFICATIONS_ARE_LOADING = "HEADER_NOTIFICATIONS_ARE_LOADING";
export const HEADER_NOTIFICATIONS_LOADING_SUCCESS = "HEADER_NOTIFICATIONS_LOADING_SUCCESS";
export const HEADER_NOTIFICATIONS_LOADING_ERROR = "HEADER_NOTIFICATIONS_LOADING_ERROR";

// CHECK WEBEX TOKENS
export const WEBEX_TOKEN_LOADING = "WEBEX_TOKEN_LOADING";
export const WEBEX_TOKEN_LOAD_SUCCESS = "WEBEX_TOKEN_LOAD_SUCCESS";
export const WEBEX_TOKEN_LOAD_ERROR = "WEBEX_TOKEN_LOAD_ERROR";